<template>
  <div class="wrapper">
    <span>{{$t('txmis.accountReward.tradeConfig')}}</span>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="tab in tabList" :label="tab.levelName" :name="tab.levelType"></el-tab-pane>
    </el-tabs>
    <el-card class="box-card" v-for="(card,dex) in update.col.data" v-show="card.levelType == activeName">
      <div class="nav_list">
        <el-form-item :label="$t('txmis.accountReward.condition')">
          <p class="item_title">{{$t('txmis.accountReward.symbolType')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.me')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.direct')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.indirect')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.quantity')}}</p>
        </el-form-item>
      </div>
      <div class="text item" v-for="(item,index) in card.value">
        <div slot="header" class="clearfix">
          <div style="float: right">
            <el-button type="text" @click="addReward(card.value)">{{$t('txmis.bt.add')}}</el-button>
            <el-button v-if="card.value.length > 1" type="text" @click="delReward(card.value,index)">{{$t('txmis.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="text item">
          <el-form-item :label="$t('txmis.accountReward.condition')+(index+1)">
            <el-select style="width: 15%" v-model="item.productType">
              <el-option
                v-for="option in productOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
            <el-input-number controls-position="right" style="width: 15%" :min="0" v-model="item.me"></el-input-number>
            <el-input-number controls-position="right" style="width: 15%" :min="0" v-model="item.direct"></el-input-number>
            <el-input-number controls-position="right" style="width: 15%" :min="0" v-model="item.indirect"></el-input-number>
            <el-input-number controls-position="right" style="width: 15%" :min="0" v-model="item.quantity"></el-input-number>
          </el-form-item>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
    export default {
        name: 'product',
        props:["update"],
        methods: {
            addReward(value,index){
                value.push({productType:'-1',me:0,direct:0,indirect:0,quantity:0});
            },
            delReward(value,index){
                value.splice(index, 1);
            }
        },
        data () {
            return {
                tabList:[
                    {"levelName":"迷你","levelType":"MIN"},
                    {"levelName":"标准","levelType":"STD"},
                    {"levelName":"铂金","levelType":"PLA"},
                ],
                activeName:"MIN",
                productOptions: [
                    {
                        value: '2',
                        label: "外汇"
                    },
                    {
                        value: '1',
                        label: "贵金属"
                    },
                    {
                        value: '5',
                        label: "指数"
                    },
                    {
                        value: '4',
                        label: "商品"
                    },
                    {
                        value: '-1',
                        label: "不限产品"
                    },
                  {
                    value: '100',
                    label: "非虚拟币"
                  },
                    {
                        value: '6',
                        label: "货币"
                    },
                    {
                        value: '7',
                        label: "股票"
                    }
                ]
            }
        }
    }
</script>
<style scoped>
  .nav_list .item_title{
    display: inline-block;
    float: left;
    width: 15.5%;
  }
</style>

